module.exports = __webpack_public_path__ + "media/images/emblems/Mezieres_FR-2004-coat_of_arms-3535139fa54aaf69598d3f6b682fa37c.svg";